<template>
  <div class="wrapper mb-5">
    <webshipper-input-label
      :label="label"
      :value="value"
      :default_value="default_value"
      @revert="update_value($event)"
    ></webshipper-input-label>
    <div class="input-group">
      <webshipper-input-liquid
        class="flex-grow-1"
        :value="value"
        v-on="$listeners"
        ref="input"
        :disable_new_lines="true"
        :fields="liquids !== null ? liquids : []"
        :display_mapped_items="true"
        :readonly="readonly"
      ></webshipper-input-liquid>
      <div class="input-group-append">
        <webshipper-input-revert
          v-if="can_revert && !readonly && default_value"
          :value="value"
          :default_value="default_value"
          @revert="update_value($event)"
          :appended="true"
        ></webshipper-input-revert>
      </div>
    </div>
  </div>
</template><script>
export default {
  props: {
    value: {
      type: String | null,
      required: true
    },
    default_value: {
      type: String | null,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false
    },
    liquids: {
      type: Array | null,
      required: false,
      default: null
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    can_revert: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      valid_input: true
    };
  },
  methods: {
    update_value(event) {
      this.$emit('input', event);
    }
  }
};
</script>
